import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { companyInfo } from '../../data/mockData';

const HeroSection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#e8d4e5] via-[#d9c5d6] to-[#c5a3c0]" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Dotted World Map Background - Africa focused */}
      <div className="absolute inset-0 opacity-20">
        <svg
          viewBox="0 0 1200 600"
          className="w-full h-full"
          preserveAspectRatio="xMidYMid slice"
        >
          {Array.from({ length: 50 }).map((_, row) =>
            Array.from({ length: 100 }).map((_, col) => {
              const x = col * 12 + 6;
              const y = row * 12 + 6;
              const isAfrica = x > 500 && x < 750 && y > 100 && y < 450;
              const rand = Math.random();
              let opacity = 0;
              if (isAfrica) {
                opacity = rand > 0.2 ? 0.7 : 0.4;
              } else if (rand > 0.9) {
                opacity = 0.15;
              }
              return (
                <circle
                  key={`${row}-${col}`}
                  cx={x}
                  cy={y}
                  r={2}
                  fill="#9B4B8C"
                  opacity={opacity}
                />
              );
            })
          )}
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="max-w-2xl"
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="text-2xl md:text-3xl text-white/90 font-light italic mb-2"
          >
            {t.hero.title}
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, x: isRTL ? 30 : -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-8"
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.2)' }}
          >
            {t.hero.subtitle}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.6 }}
            className="text-lg text-white/80"
          >
            {t.hero.description}
          </motion.p>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.6 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
          className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2"
        >
          <div className="w-1.5 h-3 bg-white/70 rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
